import { useQuery } from '@apollo/client';
import { Heading, Layout, Page, PropertyCard } from '@zillow/constellation-10';
import { GetApplicationsForUserDocument } from '../graphql/queries';
import { ApplicationsList } from '../components/ApplicationsList';

export default function ApplicationsPage() {
  const { loading, data } = useQuery(GetApplicationsForUserDocument, {
    variables: {
      includeSharedApplications: true,
    },
  });

  return (
    <Page.Root css={{ backgroundColor: 'backgroundWhite', minHeight: '100vh' }}>
      <Page.Header>
        <Heading level={1}>Your rental applications</Heading>
      </Page.Header>
      <Page.Content>
        <Layout.Root>
          <Layout.Content css={{ gridColumnEnd: 'span 12' }}>
            {data && <ApplicationsList data={data} />}
            {loading && !data && <ApplicationsLoading />}
          </Layout.Content>
        </Layout.Root>
      </Page.Content>
    </Page.Root>
  );
}

function ApplicationsLoading() {
  return (
    <>
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
    </>
  );
}
